import React, { useState } from "react";
import ModuleUsage from "./ModuleUsage/ModuleUsage";
import LLMStatus from "./LLMStatus/LLMStatus";
import NotificationSettings from "./NotificationSettings/NotificationSettings";

const SUB_TABS = [
  { label: "Module Usage",           value: "module_usage" },
  { label: "LLM Status",             value: "llm_status" },
  { label: "Notification Settings",  value: "notification_settings" },
];

export default function Admin() {
  const [activeTab, setActiveTab] = useState("module_usage");

  return (
    <div style={{ padding: "0 4px" }}>
      {/* Sub-tab bar */}
      <div style={{ display: "flex", gap: 0, borderBottom: "2px solid #e0e0e0", marginBottom: 20 }}>
        {SUB_TABS.map((tab) => {
          const isActive = tab.value === activeTab;
          return (
            <button
              key={tab.value}
              onClick={() => setActiveTab(tab.value)}
              style={{
                padding: "8px 20px",
                background: "none",
                border: "none",
                borderBottom: isActive ? "2px solid #1976d2" : "2px solid transparent",
                marginBottom: -2,
                fontSize: 13,
                fontWeight: isActive ? 600 : 400,
                color: isActive ? "#1976d2" : "#666",
                cursor: "pointer",
                transition: "color 0.15s",
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {activeTab === "module_usage"          && <ModuleUsage />}
      {activeTab === "llm_status"            && <LLMStatus />}
      {activeTab === "notification_settings" && <NotificationSettings />}
    </div>
  );
}
